<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tiObqj/images/9780814798928.jpg?1701092112508" alt="This image is the cover for the book Rise and Fall of the Caucasian Race"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rise and Fall of the Caucasian Race
      </h1>
      <p class="bookDescription body article font2">
        <p>The term “Caucasian” is a curious invention of the modern age. Originating in 1795, the word identifies both the peoples of the Caucasus Mountains region as well as those thought to be “Caucasian”. Bruce Baum explores the history of the term and the category of the “Caucasian race” more broadly in the light of the changing politics of racial theory and notions of racial identity. With a comprehensive sweep that encompasses the understanding of "race" even before the use of the term “Caucasian,” Baum traces the major trends in scientific and intellectual understandings of “race” from the Middle Ages to the present day.<br/> Baum’s conclusions make an unprecedented attempt to separate modern science and politics from a long history of racial classification. He offers significant insights into our understanding of race and how the “Caucasian race” has been authoritatively invented, embraced, displaced, and recovered throughout our history.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bruce Baum
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New york University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?dfeededa